export default class SearchFaqQuestions {
  constructor(element) {
    this.element = element;

    this.searchInput = document.getElementById("search-faq");
    this.suggestionsBox = document.getElementById("suggestions");
    this.lang = document.querySelector("html").getAttribute("lang");
    this.url = this.element.dataset.baseUrl;

    this.init();
  }

  init() {
    this.searchInput.addEventListener("input", this.search.bind(this));
    this.searchInput.addEventListener("focus", this.search.bind(this));
    this.suggestionsBox.addEventListener("click", this.selectSuggestion.bind(this));
    document.addEventListener("click", this.closeSuggestion.bind(this));
  }

  search(event) {
    const query = event.target.value;

    if (query.length > 2) {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/controllers/faq/search_faq_questions.php", true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = () => {
        if (xhr.status === 200) {
          this.suggestionsBox.style.display = "block";
          this.suggestionsBox.innerHTML = xhr.responseText;
        }
      };
      xhr.send("query=" + encodeURIComponent(query) + "&lang=" + encodeURIComponent(this.lang) + "&url=" + encodeURIComponent(this.url));
    } else {
      this.suggestionsBox.style.display = "none";
    }
  }

  selectSuggestion(e) {
    const suggestion = e.target.closest(".suggestion-item[data-url]");
    if (!suggestion) return;

    const targetUrl = suggestion.getAttribute("data-url");
    const faqComponent = document.querySelector('[data-component="FAQ"]');

    if (faqComponent) {
      faqComponent.dispatchEvent(new CustomEvent("faq:navigate", {
        detail: { url: targetUrl }
      }));
      this.suggestionsBox.style.display = "none";
      return;
    }

    window.location.href = targetUrl;
  }

  closeSuggestion(e) {
    if (!e.target.closest("#search-faq, #suggestions")) {
      this.suggestionsBox.style.display = "none";
    }
  }
}
